import * as React from 'react';
import { TextInput } from './TextInput';
import './TextInputField.css';

type TextInputFieldProps = Omit<React.ComponentProps<typeof TextInput>, 'onChange'> & {
	onChange?: (e: any) => void;
	padding?: boolean;
};

const TextInputField: React.FC<TextInputFieldProps> = ({ onChange = () => {}, padding = true, className, ...props }) => (
	<TextInput
		{...props}
		onChange={onChange}
		className={[!padding && 'text-input-field--no-padding', className].filter(Boolean).join(' ') || undefined}
	/>
);

export default TextInputField;

